import { useEffect } from "react";
import { withRouter } from "react-router-dom";
import { useUpdateNoticeCount } from "Utils/useUpdateNoticeCount";

// 页面切换时做一些处理
export const NavigateListener = withRouter(() => {
    // 更新消息数
    const update = useUpdateNoticeCount();
    useEffect(update);
    return null;
});
